"use client";

import { focusManager } from "@tanstack/react-query";
import { useEffect } from "react";

export function FocusManager(): null {
  useEffect(() => {
    return focusManager.setEventListener((setFocused) => {
      const controller = new AbortController();
      const { signal } = controller;

      const isFocused = () => document.visibilityState === "visible" && document.hasFocus();

      const onFocus = () => {
        setFocused(true);
      };

      const onBlur = () => {
        setFocused(false);
      };

      const onVisibilityChange = () => {
        setFocused(isFocused());
      };

      window.addEventListener("blur", onBlur, { signal });

      window.addEventListener("focus", onFocus, { signal });

      document.addEventListener("visibilitychange", onVisibilityChange, { signal });

      setFocused(isFocused());

      return () => {
        controller.abort();
      };
    });
  }, []);

  return null;
}
